<template>
  <div class="pt-3 px-3 mb-3 light-gray-container">
    <TitleBreadCrumb
      class="return-to-school-title"
      :has-route="false"
      :page="{
        icon: 'fas fa-flag',
        title: 'Recomendado',
      }"
    />

    <div class="row px-4 pt-2 pb-4">
      <div class="col-12 col-md-3">
        <div v-if="false">
          <CustomDropDown
          v-model="recommendationType"
          :options="[recommendationType]"
          fieldkey="id"
          fieldname="name"
          label="Recomendado por:"
          :disabled="true"
          />
          <CustomDropDown
          v-if="showAssistantDropDown"
          class="pt-4"
          v-model="assistant"
          :options="[assistant]"
          fieldkey="id"
          fieldname="name"
          label="Nombramiento de Asistente:"
          :disabled="true"
          />
        </div>
        <div class="mt-2" v-else-if="authorizationNumber">
          <div>
            <label for="" style="color:#727272">Número de Autorización:</label>
          </div>
          <input type="text"  v-model="authorizationNumber" class="control-input" style="padding-left:12px" disabled>
        </div>
      </div>

      <div class="col-12 col-md-9">
        <CustomTextArea
          v-model="description"
          label="Comentario:"
          style="width:100%"
          :maxlength="3000"
          :classes="['eq-field', 'text-left']"
          :rows="5"
          :disabled="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TitleBreadCrumb from 'TitleBreadCrumb';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from "CustomTextArea";
import CustomInput from 'CustomInput'
import { getRecommendedInformation } from '@/modules/human-resources/api';
const REGULAR_RECOMENDATION_TYPE_ID = 1;

export default {
  name: 'Saee10RecommendedInformation',
  components: {
    TitleBreadCrumb,
    CustomDropDown,
    CustomTextArea,
    CustomInput,
  },
  props: {
    requestId: {
      type: String,
      default: null,
    },
    recommendationTypes: {
      type: Array,
      default: [],
    },
  },
  data: () => ({
    recommendationType: null,
    assistant: null,
    description: null,
    authorizationNumber: null,
  }),
  methods: {
    async fetchInfo() {
      const data = await getRecommendedInformation(this.requestId);

      this.assistant = data.assitant;
      this.description = data.description;
      this.authorizationNumber = data.authorizationNumber;
      this.recommendationType = this.recommendationTypes.find(
        (x) => x.id === data.recommendationTypeId
      );
    }
  },
  computed: {
    showAssistantDropDown() {
      return this.recommendationType?.id == REGULAR_RECOMENDATION_TYPE_ID && this.assistant && this.assistant?.id > 0; 
    },
  },
  async mounted() {
    await this.fetchInfo();
  },
};
</script>

<style scoped>
.light-gray-container {
  background: #f7f7f7;
  border-radius: 5px;
  border-left: 6px solid #2db782;
}

::v-deep .fas.fa-flag {
  font-size: 16px;
  color: #2db782;
}

::v-deep .dot {
  padding: 0 !important;
}

::v-deep .tag-badge {
  background: none !important;
}

::v-deep .tag-badge-title {
  font-size: 16px !important;
}
</style>
